/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Reason for the ImageExport Ready condition.
 */
export enum ImageExportConditionReason {
  ImageExportConditionReasonPending = 'Pending',
  ImageExportConditionReasonConverting = 'Converting',
  ImageExportConditionReasonPushing = 'Pushing',
  ImageExportConditionReasonCompleted = 'Completed',
  ImageExportConditionReasonFailed = 'Failed',
  ImageExportConditionReasonCanceling = 'Canceling',
  ImageExportConditionReasonCanceled = 'Canceled',
}
